import React from 'react';
import styled from 'react-emotion';

import CreateEventForm from './CreateEventForm/CreateEventForm';
import PageHeader from '../../components/PageHeader/PageHeader';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

class CreateEvent extends React.Component {
  render() {
    return (
      <Container>
        <PageHeader>Create an event</PageHeader>
        <CreateEventForm />
      </Container>
    );
  }
}

export default CreateEvent;



// WEBPACK FOOTER //
// ./src/views/CreateEvent/CreateEvent.js